import type { ProductItemInterface } from './ProductItemInterface';
import type {
  ProductItemAttributesInterface,
  ProductItemAttributesValue,
} from './ProductItemAttributesInterface';

export class ProductItem implements ProductItemInterface {
  public productFamilyName: string = '';
  public productName: string = '';
  public units: number = 0;
  public attributes: ProductItemAttributesInterface = {};
  public sku: string = '';

  public attributesToString(): string {
    return Object.entries(this.attributes)
      .map(([key, value]) => `|${key}:${value}|`)
      .join('');
  }

  public setAttrValue(attrName: string, attrValue: ProductItemAttributesValue): void {
    if (typeof attrValue === 'string') {
      if (attrValue.toLowerCase() === 'true') {
        attrValue = true;
      } else if (attrValue.toLowerCase() === 'false') {
        attrValue = false;
      }
    }

    if (Array.isArray(attrValue)) {
      const v = attrValue.map((value) => {
        if (typeof value === 'string') {
          if (value.toLowerCase() === 'true') {
            return true;
          } else if (value.toLowerCase() === 'false') {
            return false;
          }
        }
        return value;
      });
      attrValue = v as ProductItemAttributesValue;
    }

    this.attributes[attrName] = attrValue;
  }

  public removeAttr(attributeName: string, attributeValue: string | number): void {
    if (Array.isArray(this.attributes[attributeName])) {
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      const preferred = this.attributes[attributeName] as Array<any>;
      this.attributes[attributeName] = preferred?.filter((value) => value != attributeValue);
    } else {
      this.attributes[attributeName] = null;
    }
  }

  public getAttrValue<T = ProductItemAttributesValue>(attrName: string): T {
    return this.attributes?.[attrName] as T;
  }

  public fromJSON(json: ProductItemInterface) {
    Object.assign(this, json);
  }

  public toJSON(): ProductItemInterface {
    return {
      productFamilyName: this.productFamilyName,
      productName: this.productName,
      units: this.units,
      attributes: { ...this.attributes },
      sku: this.sku,
    };
  }

  public toTestableOneDimensionalObject(): Record<string, unknown> {
    const oneDimensionalObject: Record<string, unknown> = {
      'item.productFamilyName': this.productFamilyName,
      'item.productName': this.productName,
      'item.units': this.units,
      'item.sku': this.sku,
    };

    Object.entries(this.attributes).forEach(([key, value]) => {
      oneDimensionalObject[`item.attributes.${key}`] = value;
    });

    return oneDimensionalObject;
  }
}
